import React from 'react'
import ReceiptRules from 'src/app/Receipt Rules/ReceiptRules'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { expenseRequirementsReceiptRulesRouteProps } from 'src/navigation/routeProps'

const ExpenseRequirementsReceiptRulesAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsExpenseRequirementsReceiptRules,
  routeProps: expenseRequirementsReceiptRulesRouteProps,
  component: <ReceiptRules />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default ExpenseRequirementsReceiptRulesAppRoute
